var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDrivers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "conductores_main",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 34,
    height: 34,
    transform: "translate(767 649)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 24.572,
    height: 25.708,
    fill: "#707070"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_19",
    "data-name": "Mask Group 19",
    transform: "translate(-767 -649)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(771.714 653.146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M0,23.047c.064-.487.111-.977.2-1.46a12.231,12.231,0,0,1,9.046-9.693c.056-.014.111-.036.189-.062A6.22,6.22,0,0,1,6.055,6.374a5.988,5.988,0,0,1,1.889-4.6A6.259,6.259,0,1,1,15.2,11.817c.524.174,1.063.315,1.571.528a12.044,12.044,0,0,1,7.677,9.572,7,7,0,0,1,.1,1.794A2.208,2.208,0,0,1,22.7,25.663a.634.634,0,0,0-.112.045H18.626c-.054-.018-.106-.039-.161-.053a2.253,2.253,0,0,1-1.741-1.713c-.017-.062-.03-.124-.052-.216l-1.1.64c.164.815.1.987-.458,1.341h-.4a1,1,0,0,1-.584-.825,1.851,1.851,0,0,0-3.647-.009.968.968,0,0,1-.639.835H9.589c-.3-.1-.577-.255-.608-.594a6.144,6.144,0,0,1,.052-.936l-1.089-.63c-.011.083-.016.14-.025.2a2.227,2.227,0,0,1-1.73,1.892c-.121.027-.244.048-.366.072H1.958c-.054-.017-.106-.039-.161-.052A2.158,2.158,0,0,1,.3,24.541,6.009,6.009,0,0,1,0,23.7v-.653m20.746,1.139c.055.006.08.011.1.011.452,0,.9,0,1.355,0a.794.794,0,0,0,.872-.941,15.936,15.936,0,0,0-.353-2.249,10.775,10.775,0,0,0-11.5-7.932,10.489,10.489,0,0,0-6.761,3.317,10.49,10.49,0,0,0-2.952,6.951.757.757,0,0,0,.823.853c.427,0,.853,0,1.28,0,.08,0,.159-.008.232-.011V22.693c-.133,0-.25,0-.366,0a.764.764,0,0,1-.77-.762.754.754,0,0,1,.785-.742c.36,0,.72-.015,1.079,0a.43.43,0,0,0,.439-.237,8.634,8.634,0,0,1,8.818-3.845,8.547,8.547,0,0,1,5.792,3.909.325.325,0,0,0,.323.171c.393-.01.786-.008,1.179,0a.749.749,0,0,1,.758.742.76.76,0,0,1-.72.758c-.138.01-.278,0-.421,0ZM10.421,1.924a4.734,4.734,0,0,0,3.123,8.913A4.655,4.655,0,0,0,17.011,6a4.956,4.956,0,0,1-6.59-4.074m7.516,19.33a7.1,7.1,0,0,0-11.161-.128l1.517.88,1.534.89c.081-.075.148-.137.216-.2a3.367,3.367,0,0,1,4.667.151.262.262,0,0,0,.394.052c.941-.557,1.89-1.1,2.833-1.647M11.9,1.55a3.377,3.377,0,0,0,1.731,2.767,3.306,3.306,0,0,0,3.05.166A4.66,4.66,0,0,0,11.9,1.55M5.391,22.707v1.465a.868.868,0,0,0,.91-.3.748.748,0,0,0,.026-.829c-.208-.363-.557-.377-.936-.336m13.826,0a.844.844,0,0,0-.927.339.729.729,0,0,0,.038.843.8.8,0,0,0,.889.267Z",
    transform: "translate(0 0)",
    fill: "#707070"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrivers);
export default __webpack_public_path__ + "static/media/icon_drivers.b7b1050134054221910d48400c374099.svg";
export { ForwardRef as ReactComponent };